import { render, staticRenderFns } from "./FeedbackListDetail.vue?vue&type=template&id=8a6a9dc8&scoped=true&"
import script from "./FeedbackListDetail.vue?vue&type=script&lang=js&"
export * from "./FeedbackListDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackListDetail.vue?vue&type=style&index=0&id=8a6a9dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6a9dc8",
  null
  
)

export default component.exports